var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-sale-chart-home"},[_c('div',{staticClass:"d-flex align-items-center flex-wrap justify-content-lg-between mb-6 gap-3"},[_c('snow-select',{attrs:{"options":[
        { id: '', name: 'Todos os produtos' } ].concat( _vm.products.map(function (ref) {
              var id = ref.id;
              var name = ref.name;

              return ({ id: id, name: name });
})
      )},on:{"input":function (v) { return _vm.$emit('change-product', v); }},model:{value:(_vm.filters.product_id),callback:function ($$v) {_vm.$set(_vm.filters, "product_id", $$v)},expression:"filters.product_id"}}),_c('snow-select',{attrs:{"options":[
        { id: 1, name: '1 dia' },
        { id: 7, name: '7 dias' },
        { id: 15, name: '15 dias' },
        { id: 30, name: '30 dias' }
      ]},on:{"input":function (v) { return _vm.$emit('change-dates', v); }},model:{value:(_vm.filters.period),callback:function ($$v) {_vm.$set(_vm.filters, "period", $$v)},expression:"filters.period"}})],1),_c('div',{staticClass:"chart-card"},[_c('line-chart',{attrs:{"data":_vm.revenuesByDay}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }